export default "__VITE_ASSET__CYy3tPUr__"